import type { LegislativeStatusPublicGetAllResponse } from '@govinity/validation/public';

import { ReadOnlyApi } from '../base';

export class LegislativeStatusesApi extends ReadOnlyApi<
  LegislativeStatusPublicGetAllResponse,
  object,
  object
> {
  parentPath: string;
  governmentCode: string;

  constructor(governmentCode: string, parentPath: string) {
    super();

    this.parentPath = parentPath;
    this.governmentCode = governmentCode;
  }

  getPath() {
    return `${this.parentPath}/${this.governmentCode}/legislative-statuses`;
  }
}
